import { render, staticRenderFns } from "./ModalAnonymizationContact.vue?vue&type=template&id=01498618&scoped=true&"
import script from "./ModalAnonymizationContact.vue?vue&type=script&lang=js&"
export * from "./ModalAnonymizationContact.vue?vue&type=script&lang=js&"
import style0 from "./ModalAnonymizationContact.vue?vue&type=style&index=0&id=01498618&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01498618",
  null
  
)

export default component.exports